import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DataGridCellContext } from '../../../data-grid/data-grid.model';
import { SamplesGridTemplateContainer } from '../template-container';
import { SamplesGridDataCellData } from '../../samples-grid.model';
import { SampleValidationErrorLevel } from '../../../../samples/model/sample-management.model';
import { ToolTip } from '../../../../shared/tooltip/tooltip.model';
import { samplesGridDataCellToolTips } from './data-cell-tool-tips';
// import { SoftLineBreaksPipe } from '../../../../shared/presentation/pipes/soft-line-breaks.pipe';

@Component({
    standalone: false,
    selector: 'mibi-samples-grid-data-cell-template',
    templateUrl: './data-cell-template.component.html',
    styleUrls: ['./data-cell-template.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SamplesGridDataCellTemplateComponent extends SamplesGridTemplateContainer<DataGridCellContext> {

    toolTipsOf(data: SamplesGridDataCellData): ToolTip[] {
        return samplesGridDataCellToolTips(data);
    }

    hasError(data: SamplesGridDataCellData): boolean {
        return this.hasErrorLevel(data, SampleValidationErrorLevel.ERROR);
    }

    hasWarning(data: SamplesGridDataCellData): boolean {
        return this.hasErrorLevel(data, SampleValidationErrorLevel.WARNING);
    }

    hasAutoCorrection(data: SamplesGridDataCellData): boolean {
        return this.hasErrorLevel(data, SampleValidationErrorLevel.AUTOCORRECTED);
    }

    hasCorrectionOffers(data: SamplesGridDataCellData): boolean {
        return data.correctionOffer.length > 0;
    }

    isEdited(data: SamplesGridDataCellData): boolean {
        return data.oldValue !== undefined;
    }

    private hasErrorLevel(data: SamplesGridDataCellData, level: SampleValidationErrorLevel): boolean {
        return data.errors.some((error) => error.level === level);
    }
}
